<script>
  import { Label } from "sveltestrap";
  import {
    viewSpecs,
    systemLog,
    activeSpec,
    currentSpec,
    menuConfig,
    queryRecStack,
    saveToRecStacks,
    SKEY,
    soloUnlock,
    setSoloUnlock,
    unlockedSpecs,
    setUnlockedSpecsMemory,
    updateUnlockedSpecs,
    currMenu,
  } from "../../editor/storage.js";
  import { firstLevelMenus } from "../../editor/menuSchema.js";
  import {
    deviceTypes,
    moveToArtboard,
  } from "../../editor/component/artboard.js";
  import {
    openSystemTooltip,
    closeSystemTooltip,
  } from "../../editor/utility.js";
  import {
    forceRefrechRecs,
    setExplorationMode,
  } from "../../editor/exploration/exploration.js";

  let curr,
    stack,
    subMenu,
    currArtboardName,
    artboardInfo = {},
    back_to;
  function setSubMenu(s, c) {
    subMenu = s;
    curr = c;
    stack = $systemLog.query({ category: "recommender", artboard_uid: c });
    stack.forEach((item) => {
      if (item.data.message === "Hide a design suggestion") {
        item.revertible =
          queryRecStack(SKEY.LLT, item.data.stack_id).length == 1 ? 1 : -1;
      }
    });
    stack.reverse();
    activeSpec.set(c);
    moveToArtboard(c);
    currArtboardName = $currentSpec.artboard.name;
    $viewSpecs.forEach((spec) => {
      artboardInfo[spec.uid] = {
        device: spec.artboard.screen_type,
        name: spec.artboard.name,
      };
    });
  }
  function cancelSubMenu() {
    subMenu = undefined;
    curr = undefined;
    stack = undefined;
    currArtboardName = undefined;
  }
  menuConfig.subscribe((config) => {
    if (config?.artboard_uid) {
      setSubMenu("view", config.artboard_uid);
      if (config.back_to) back_to = config.back_to;
    }
  });

  function revertLessLikeThis(i, stack_id, descs, source, target) {
    if (stack_id) {
      saveToRecStacks(SKEY.LLT, "remove", [
        {
          stack_id,
        },
      ]);
      stack[i].revertible = -1;
      forceRefrechRecs.set(true);
      $systemLog.log({
        message: "Revert a hidden suggestion",
        artboard_uid: target,
        source_uid: source,
        category: "recommender",
        recommendation: descs,
        stack_id,
      });
    }
  }

  function setSolo(uid) {
    if ($soloUnlock === undefined) {
      // nothing is solo-unlocked
      setSoloUnlock(uid);
      setUnlockedSpecsMemory($unlockedSpecs);
      updateUnlockedSpecs([uid]);
      $systemLog.log({
        message: "Set solo from exploration history",
        artboard_uid: uid,
      });
    } else if ($soloUnlock !== undefined && $soloUnlock !== uid) {
      // there's existing solo-unlock
      setSoloUnlock(uid);
      updateUnlockedSpecs([uid]);
      $systemLog.log({
        message: "Set solo from exploration history",
        artboard_uid: uid,
      });
    }
  }
  function runRecommender(mode, uid) {
    // console.log($activeSpec !== uid);
    // if ($activeSpec !== uid) return;
    if ($soloUnlock !== uid) setSolo(uid);
    setExplorationMode(mode, uid);
    $systemLog.log({
      message: "Run " + mode + " from exploration history",
      artboard_uid: uid,
    });
  }
</script>

{#if !subMenu}
  <h2>
    {firstLevelMenus["exploration_history"]?.title || "Exploration history"}
  </h2>
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <p class="text-sm">
        Choose an artboard to browse the exploration history for.
      </p>
    </div>
  </div>
  {#if $viewSpecs?.length > 0}
    <div class="pane-divider" />
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-form-row">
        {#each $viewSpecs as spec, i}
          <button
            type="button"
            class={"menu-second-level" +
              ($activeSpec === spec.uid ? " current" : "")}
            on:click={() => {
              setSubMenu("view", spec.uid);
            }}
          >
            <i
              class={`bi bi-${
                deviceTypes[spec.artboard.screen_type].icon
              } me-1`}
            />
            {spec.artboard.name}
          </button>
        {/each}
      </div>
    </div>
  {/if}
{:else if subMenu === "view" && curr !== undefined}
  <!-- clear cache (last!) -->
  <div class="dupo-menu-pane mb-2 pt-3">
    <div class="dupo-menu-pane-row mb-2">
      <Label>Exploration history for<br />{currArtboardName}</Label>
      <p class="text-sm mb-0">
        Your history of design exploration for the artboard {currArtboardName} (newest
        to oldest).
      </p>
    </div>
  </div>
  {#if stack !== undefined && stack.length > 0}
    <div class="pane-divider" />
    <div style="height: calc(100vh - 200px); overflow-y: scroll;">
      {#each stack as s, i}
        <div class={"dupo-menu-pane"}>
          <div class="dupo-menu-pane-row">
            <h3 class="h8">
              {s.data.message}
            </h3>
            <p class="text-sm mb-2"><i class="bi bi-clock me-1" />{s.time}</p>
            {#if s.data.recommendation}
              <h4 class="h-sub">
                <i class="bi bi-braces me-1" /> Descriptions
              </h4>
              <ul class="desc-list mb-2">
                {#each s.data.recommendation as desc}
                  <li class="mb-1 rec-desc-item">{desc}</li>
                {/each}
              </ul>
            {/if}
            {#if s.data.source_uid}
              <h4 class="h-sub">Source / Target</h4>
              <div class="mb-2 px-3" style="font-size: 0.7rem;">
                <i
                  class={`bi bi-${
                    deviceTypes[artboardInfo[s.data.source_uid].device].icon
                  } me-1`}
                />{artboardInfo[s.data.source_uid].name}<br />
                <i class="bi bi-arrow-right me-1" />
                <i
                  class={`bi bi-${
                    deviceTypes[artboardInfo[s.data.artboard_uid].device].icon
                  } me-1`}
                />{artboardInfo[s.data.artboard_uid].name}
              </div>
            {/if}
            {#if s.revertible == 1}
              <div class="mb-2">
                <button
                  class="revert"
                  on:click={() => {
                    revertLessLikeThis(
                      i,
                      s.data.stack_id,
                      s.data.recommendation,
                      s.data.source_uid,
                      s.data.artboard_uid
                    );
                  }}
                  on:mouseover={(event) => {
                    openSystemTooltip(
                      event,
                      "Bring this hidden suggestion back"
                    );
                  }}
                  on:mousemove={(event) => {
                    openSystemTooltip(
                      event,
                      "Bring this hidden suggestion back"
                    );
                  }}
                  on:mouseout={() => {
                    closeSystemTooltip();
                  }}
                  on:focus={(event) => {
                    openSystemTooltip(
                      event,
                      "Bring this hidden suggestion back"
                    );
                  }}
                  on:blur={() => {
                    closeSystemTooltip();
                  }}>Revert</button
                >
              </div>
            {:else if s.revertible == -1}
              <div class="mb-2">
                <button disabled class="revert">Reverted</button>
              </div>
            {/if}
            {#if s.data.branched_uid && artboardInfo[s.data.branched_uid]}
              <h4 class="h-sub">
                <i class="bi bi-easel me-1" /> Branched artboard
              </h4>
              <div class="mb-2 px-3" style="font-size: 0.75rem;">
                <i
                  class={`bi bi-${
                    deviceTypes[artboardInfo[s.data.branched_uid]?.device]?.icon
                  } me-1`}
                />{artboardInfo[s.data.branched_uid]?.name}
              </div>
            {/if}
          </div>
        </div>
        <div class="pane-divider" />
      {/each}
    </div>
  {:else}
    <div class="pane-divider" />
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-row">
        <p class="text-sm">
          You have not explored design alternatives yet. Try out "Explore
          alternatives" button next to each artboard!
        </p>
      </div>
    </div>
    <div class="pane-divider" />
  {/if}
  <div class="dupo-menu-pane mb-2 pt-2">
    <div class="dupo-menu-pane-button-row">
      <button
        type="button"
        on:click={() => {
          if (back_to) {
            cancelSubMenu();
            currMenu.set(undefined);
            runRecommender(back_to.mode, back_to.artboard_uid);
          } else {
            cancelSubMenu();
          }
        }}><i class="bi bi-arrow-left me-1" />Go back</button
      >
    </div>
  </div>
{/if}

<style>
  h3.h8 {
    font-size: 0.8rem !important;
    font-weight: 500;
    color: #454545;
    margin-bottom: 0.25rem;
  }
  .reversed {
    display: flex;
    flex-direction: column-reverse;
  }
  .rec-desc-item {
    font-size: 0.7rem;
    color: #454545;
    line-height: 1.2;
    line-break: anywhere;
  }
  .desc-list {
    padding: 0 0 0 1.5rem;
    border-radius: var(--default-radius);
  }
  .odd .desc-list {
    background-color: rgba(255, 255, 255, 0.6);
  }
  button.revert {
    padding: 0.25rem 0.5rem;
    width: 100%;
    display: block;
    text-align: center;
    border-radius: var(--default-radius);
    background-color: #efefef;
    color: #454545;
    border: 0;
    appearance: none;
    font-size: 0.7rem;
  }
  button.revert:disabled {
    font-style: italic;
  }
</style>
